// DroppableSlot component
import React from 'react'
import './DroppableSlot.scss'
import { GAME_TYPE } from 'steps/drag-and-drop/constants'
import { DroppableSlotMatchDrop } from './DroppableSlots'
import { DroppableSlotRanking } from './DroppableSlots/DroppableSlotRanking'

export const DroppableSlot = ({
  background,
  backgroundNumber = null,
  droppedCard,
  resetSlot,
  isCorrectAnswer,
  isWrongAnswer,
  checkingMatches = true,
  gameFinished,
  wrapperStyle,
  isDuplicateCardId,
  showCorrectAnswer,
  validatedPairs,
  gameType,
  draggableCard,
  isOccupied,
  isComingFromBottom,
  isEditorial,
}) => {
  switch (gameType) {
    case GAME_TYPE.PAIRS:
      return (
        <DroppableSlotMatchDrop
          draggableCard={draggableCard}
          isOccupied={isOccupied}
          isComingFromBottom={isComingFromBottom}
          background={background}
          droppedCard={droppedCard}
          resetSlot={resetSlot}
          isCorrectAnswer={isCorrectAnswer}
          isWrongAnswer={isWrongAnswer}
          checkingMatches={checkingMatches}
          gameFinished={gameFinished}
          gameType={gameType}
          wrapperStyle={wrapperStyle}
          isDuplicateCardId={isDuplicateCardId}
          showCorrectAnswer={showCorrectAnswer}
          validatedPairs={validatedPairs}
        />
      )
    case GAME_TYPE.RANKING:
      return (
        <DroppableSlotRanking
          isEditorial={isEditorial}
          backgroundNumber={backgroundNumber}
          draggableCard={draggableCard}
          isOccupied={isOccupied}
          isComingFromBottom={isComingFromBottom}
          background={background}
          droppedCard={droppedCard}
          resetSlot={resetSlot}
          isCorrectAnswer={isCorrectAnswer}
          isWrongAnswer={isWrongAnswer}
          checkingMatches={checkingMatches}
          gameFinished={gameFinished}
          wrapperStyle={wrapperStyle}
          isDuplicateCardId={isDuplicateCardId}
          showCorrectAnswer={showCorrectAnswer}
          validatedPairs={validatedPairs}
          gameType={gameType}
        />
      )
    case GAME_TYPE.ORDER:
      return (
        <DroppableSlotRanking
          isEditorial={isEditorial}
          backgroundNumber={backgroundNumber}
          draggableCard={draggableCard}
          isOccupied={isOccupied}
          isComingFromBottom={isComingFromBottom}
          background={background}
          droppedCard={droppedCard}
          resetSlot={resetSlot}
          isCorrectAnswer={isCorrectAnswer}
          isWrongAnswer={isWrongAnswer}
          checkingMatches={checkingMatches}
          gameFinished={gameFinished}
          wrapperStyle={wrapperStyle}
          isDuplicateCardId={isDuplicateCardId}
          showCorrectAnswer={showCorrectAnswer}
          validatedPairs={validatedPairs}
          gameType={gameType}
        />
      )
    default:
      return null
  }
}
